<template>
  <div class="card border-0 shadow-none rounded-1 mb-30">
    <div class="card-body p-xl-40">
      <h6 class="fs-18 mb-40 text-title">{{ $t("adjustment_page.selected_products_for_adjustment") }}</h6>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0 ls-1">
                {{ $t("adjustment_page.product") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("adjustment_page.product_code") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("adjustment_page.available_stock") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("adjustment_page.quantity") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("adjustment_page.type") }}
              </th>
              <th
                scope="col"
                class="text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
              >
                {{ $t("adjustment_page.delete") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) in products" :key="product.id">
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0">
                {{ product.name }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ product.code }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge fw-semibold fs-14" :class="product.availableStock > 0 ? 'badge-success-soft' : 'badge-danger-soft'">
                  {{ product.availableStock }}
                </span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <div class="quantity-cell">
                  <QuantityCounter
                    :modelValue="product.quantity"
                    @update:modelValue="$emit('update-quantity', index, $event)"
                  />
                  <small
                    v-if="product.adjustmentType === 'subtract' && product.quantity > product.availableStock"
                    class="d-block text-danger mt-2"
                  >
                    {{ $t("adjustment_page.quantity_exceeds_available_stock") }}
                  </small>
                </div>
              </td>
              <td class="shadow-none lh-1">
                <select
                  :value="product.adjustmentType"
                  class="select-cat fs-14 fw-medium border-0 bg-transparent"
                  @change="$emit('update-type', index, ($event.target as HTMLSelectElement).value)"
                >
                  <option value="add">{{ $t("adjustment_page.addition") }}</option>
                  <option value="subtract">{{ $t("adjustment_page.deduction") }}</option>
                </select>
              </td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div
                  class="button-group style-two ms-auto d-flex flex-wrap align-items-center"
                >
                  <a
                    class="delete-btn cursor-pointer"
                    @click="$emit('remove', index)"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      :alt="$t('adjustment_page.delete')"
                    />
                  </a>
                </div>
              </td>
            </tr>
            <tr v-if="products.length === 0">
              <td colspan="6" class="text-center py-4 text-muted">
                {{ $t("adjustment_page.no_products_selected") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QuantityCounter from "../../Purchases/CreatePurchase/QuantityCounter.vue";

interface AdjustmentProductRow {
  id?: number;
  name?: string;
  code?: string;
  quantity: number;
  adjustmentType: "add" | "subtract";
  availableStock: number;
}

export default defineComponent({
  name: "SelectedProducts",
  components: {
    QuantityCounter,
  },
  props: {
    products: {
      type: Array as () => AdjustmentProductRow[],
      default: () => []
    }
  },
  emits: ['remove', 'update-quantity', 'update-type']
});
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.select-cat {
  height: 36px;
  border-radius: 2px;
  background: #ececec;
  width: 190px;
  padding-left: 16px;
  background-image: url(../../../assets/img/icons/down-arrow-4.svg);
  background-repeat: no-repeat;
  background-size: 10px;
  background-position: calc(100% - 16px) 16px;
  outline: none;
}

.quantity-cell {
  min-width: 150px;
}

.badge-success-soft {
  background: #e8f7ee;
  color: #1f9254;
}

.badge-danger-soft {
  background: #fdecec;
  color: #d33c43;
}
</style>
